import React, {useContext} from 'react';
import {QuestionsContext} from '../context/questions';
import Fade from 'react-reveal/Fade';

const Link = ({item}) => {
    const link = item.URL.uri.split(":")[1];
    const title = item.URL.title ? item.URL.title : "Get More Information";
    //Has a capital letter due to given data
    const cleanMessage = item.Message === false ? "" : item.Message;
    const {clearList} = useContext(QuestionsContext);

    return <Fade bottom>
        <div className="no-loan">
            <div className="titleArea">
                <div dangerouslySetInnerHTML={{__html: cleanMessage }} />
                <div className="utility-buttons">
                    <button 
                        className="su-button su-reset"
                        onClick={clearList} 
                        >
                        Reset
                    </button>
                    <a className="su-button" href={link}>{title}</a>
                </div>
            </div>
        </div>
    </Fade>
    
}

export default Link;